<!--  -->
<template>
  <div>
    <div>
      <div class="pull_box">
        <el-button type="primary" @click="pullmemberclick">拉取群成员</el-button>
        <el-button type="primary" @click="batchremove">批量移除</el-button>
      </div>
      <el-table
        ref="table"
        :data="publicAdvelist"
        border=""
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        />
        <el-table-column
          prop="userNum"
          label="头像"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <img :src="scope.row.avatar" class="avatar_box" alt="">
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名字"
          align="center"
        />
        <el-table-column
          prop="name"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="remove(scope.row)">移除</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="real_name"
          label="创建人"
          align="center"
        />
        <el-table-column
          prop="created_at_text"
          label="创建时间"
          align="center"
        /> -->
      </el-table>
    </div>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="拉取成员"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="45%"
    >
      <pullmember ref="pullmemberdom" @pullupdata="pullupdata" />
    </el-dialog>
  </div>
</template>

<script>
import { getquanlist, removemembers } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import pullmember from './pullmember.vue'
export default {
  components: {
    PaginationRight,
    pullmember
  },
  data() {
    return {
      arr: [],
      items: null,
      page: 1,
      pageSize: 10,
      total: null,
      publicAdvelist: [],
      dialogVisible: false,
      removeSelection: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(item) {
      this.items = item
      this.getdquanlisst()
    },
    async getdquanlisst() {
      const data = await getquanlist({
        chatKeyId: this.items.id,
        page: this.page,
        pageSize: this.pageSize
      })
      this.publicAdvelist = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageSize = e
      this.getdquanlisst()
    },
    fetchCurrentPage(e) {
      this.page = e
      this.getdquanlisst()
    },
    pullmemberclick() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.pullmemberdom.send(this.items)
      })
    },
    pullupdata() {
      this.dialogVisible = false
      this.getdquanlisst()
    },
    remove(itemrw) {
      this.$confirm(`确定要移除${itemrw.name}吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        // 群聊移除成员
        removemembers({
          chatId: this.items.chatId,
          idList: [itemrw.openId]
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '移除成功!'
          })
          this.getdquanlisst()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    handleSelectionChange(val) {
      const allselect = val.map(re => re.openId)
      this.removeSelection = allselect
    },
    batchremove() {
      // eslint-disable-next-line eqeqeq
      if (this.removeSelection.length == 0) {
        this.$message.error('请选择要移除的成员')
        return
      }
      this.$confirm('确定要移除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        // 群聊移除成员
        removemembers({
          chatId: this.items.chatId,
          idList: this.removeSelection
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '移除成功!'
          })
          this.getdquanlisst()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tagname{
  margin-right: 10px;
}
.avatar_box{
  width: 50px;
  height: 50px;
}
.pull_box{
  text-align: right;
  margin-bottom: 10px;
}
</style>
